import { Moment } from 'moment'
import React from 'react'

import CalendarDateRangePicker from 'components/Common/Calendar/DateRangePicker'

interface Props {
  startDate?: Moment
  endDate?: Moment
  initDate?: Moment
  minDate?: Moment
  maxDate?: Moment
  onChangeStartDate: (date?: Moment) => void
  onChangeEndDate: (date?: Moment) => void
}

function DateRangePicker({
  startDate,
  endDate,
  initDate,
  onChangeStartDate,
  onChangeEndDate,
  minDate,
  maxDate,
}: Props) {
  return (
    <CalendarDateRangePicker
      onDatesChange={(dates) => {
        onChangeStartDate(dates.startDate)
        onChangeEndDate(dates.endDate)
      }}
      startLabel="Start date"
      endLabel="End date"
      startDate={startDate}
      endDate={endDate}
      initDate={initDate}
      minDate={minDate?.toDate()}
      maxDate={maxDate?.toDate()}
    />
  )
}

export default DateRangePicker
